/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IICD10Diagnosis } from 'app/shared/model/icd-10-diagnosis.model';
import { ITemplatePrescription } from 'app/shared/model/template-prescription.model';

export interface ITemplateDiagnosis {
  id?: string;
  snomedConceptId?: string;
  snomedConceptText?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  icd10diagnosis?: IICD10Diagnosis;
  prescription?: ITemplatePrescription | null;
}

export const defaultValue: Readonly<ITemplateDiagnosis> = {
  active: false,
};
